<template>
	<div v-click-outside="closePopover" class="overflow-hidden" @keyup.escape="closePopover">
		<div class="flex items-center h-28 bg-gray-650 border rounded border-gray-550 hover:bg-gray-600 px-10 gap-8">
			<div class="flex-grow flex items-center overflow-hidden">
				<BaseTooltip
					:text="tooltipText"
					:enabled="enableTooltip(tooltipText.length)"
					placement="left"
					class="flex-grow"
					:modifiers="[{name: 'offset', options: {offset: [0, 12]}}]"
				>
					<a
						:href="integrationUrl"
						target="_blank"
						rel=""
						class="inline-flex items-center h-28 w-full select-none"
						:title="tooltipText"
					>
						<BaseIcon :name="integration.type" class="flex-none" />
						<span
							class="w-full ml-8 truncate"
							:class="{capitalize: integration.type !== 'slack'}"
							:style="`max-width: ${maxCharactersInButtonText}ch`"
						>
							{{ buttonText }}
						</span>
					</a>
				</BaseTooltip>
			</div>
			<BaseTooltip v-if="removeable" text="Remove" placement="bottom">
				<button class="flex-shrink-0 p-2 text-gray-400" @click="popoverVisible = !popoverVisible">
					<BaseIcon name="mono/delete" class="w-10 h-10 -mt-2" />
				</button>
			</BaseTooltip>
		</div>
		<Popper :isVisible="popoverVisible" placement="bottom-end">
			<template #popup>
				<BasePopover data-test="delete-session-link-confirmation">
					<p class="px-12 py-4 text-gray-300">
						Remove this link to the <span class="capitalize">{{ integration.type }}</span> issue?
					</p>
					<template #footer>
						<div class="flex justify-end mt-4 mx-4">
							<button
								data-test="cancel-button"
								class="mr-16 link-gray"
								:disabled="isDeleting"
								@click="closePopover"
							>
								Cancel
							</button>
							<BaseButton
								data-test="confirm-button"
								class="button-red text-strong-base"
								:loading="isDeleting"
								@click="confirmDelete"
							>
								Remove
							</BaseButton>
						</div>
					</template>
				</BasePopover>
			</template>
		</Popper>
	</div>
</template>

<script>
import Popper from 'shared/components/Popper.vue'
import deleteSessionIntegration from 'shared/apollo/deleteSessionIntegration'
import {useSessionIntegrationLink} from 'shared/composables/useSessionIntegrationLink'

export default {
	name: 'SessionDetailsIntegrationLink',
	components: {
		Popper,
	},
	props: {
		integration: {type: Object, required: true},
		removeable: {type: Boolean, default: false},
	},
	setup(props) {
		const {integrationUrl, tooltipText, buttonText} = useSessionIntegrationLink(props.integration)
		return {integrationUrl, tooltipText, buttonText}
	},
	data() {
		return {
			popoverVisible: false,
			isDeleting: false,
			maxCharactersInButtonText: 24,
		}
	},
	methods: {
		enableTooltip(tooltipTextLength) {
			return tooltipTextLength > this.maxCharactersInButtonText
		},
		async confirmDelete() {
			if (!this.removeable) return
			this.isDeleting = true
			await deleteSessionIntegration({
				id: this.integration.id,
				sessionId: this.$route.params.sessionId,
				userId: this.$auth.userId.value,
			})
			this.isDeleting = false
			this.closePopover()
		},
		closePopover() {
			this.popoverVisible = false
		},
	},
}
</script>
